import { Icon } from "@/components/icon";
import Link from "next/link";
import { usePath } from "@/contexts/path/path";
import css from "@/components/Listing/ListingScreen/.module.scss";
import {
  getAdPromotionItemObject,
  trackAdPromoClickInteraction,
  trackAdPromoViewInteraction,
  trackSelectAdPromotion,
  trackViewAdPromotion,
} from "@/lib/tracking/trackAdPromotionEvents";
import { useEffect } from "react";

function PromotionControl({ listing }) {
  const { category, listingType, categoriesDictionary, previousPath } =
    usePath();

  useEffect(() => {
    trackViewAdPromotion({
      listingType,
      category: category?.en,
      item: getAdPromotionItemObject({
        listing,
        index: 1,
        categoriesDictionary,
      }),
    });
    trackAdPromoViewInteraction({
      listingType,
      category: category?.en,
      listingName: listing.title,
      listingId: listing.id,
      source: previousPath || decodeURI(document?.referrer),
    });
  }, []);

  if (!listing.published) return null;

  return (
    <Link
      className={css.card + " " + css.sov_owner_btn + " " + css.promotion}
      href={`/user/promotion?id=${listing.id}&listing_type=${listingType}&category=${category?.en}`}
      onClick={() => {
        trackSelectAdPromotion({
          listingType,
          category: category?.en,
          item: getAdPromotionItemObject({
            listing,
            index: 1,
            categoriesDictionary,
          }),
        });
        trackAdPromoClickInteraction({
          listingType,
          category: category?.en,
          listingName: listing.title,
          listingId: listing.id,
          source: previousPath || decodeURI(document?.referrer),
        });
      }}
    >
      <Icon
        className={css.mainIcon}
        asSVG
        width={30}
        height={30}
        name="promotion"
      />
      <div>
        <h4> ترويج الإعلان</h4>
        <p>خدمات تساعدك على تسريع بيع أو تأجير العقار</p>
      </div>
      <Icon
        className={css.arrow}
        asSVG
        width={25}
        height={25}
        name="RightArrow-colored"
      />
    </Link>
  );
}

export default PromotionControl;
